import { render, staticRenderFns } from "./OptionMenu.vue?vue&type=template&id=3c5c3582&scoped=true"
import script from "./OptionMenu.vue?vue&type=script&lang=js"
export * from "./OptionMenu.vue?vue&type=script&lang=js"
import style0 from "./OptionMenu.vue?vue&type=style&index=0&id=3c5c3582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c3582",
  null
  
)

export default component.exports